import { FirebaseMessagingService } from './firebase-messaging.service';
import { NegociosService } from './negocios-service';
import { SignalrService } from '../signalr/signalR.service';
import { PATH_LOGIN } from '../navigation/navigation.module';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClient } from './http-client';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import * as jwt_decode from 'jwt-decode';
import { PermisosService } from './permisos-service';
import {AgrisService} from './agris-service';
import {environment} from '../../environments/environment';

@Injectable()
export class AuthenticationService {

    private logger = new Subject<boolean>();
    private logoutStopCondition: boolean = false;

    constructor(private httpClient: HttpClient,
                private router: Router,
                private firebaseService: FirebaseMessagingService,
                private negociosService: NegociosService,
                private signalRService: SignalrService,
                private permisosService: PermisosService,
                private agrisService: AgrisService,
    ) {

        httpClient.tokenExpired().subscribe(expired => {
          if (expired) {
            this.logout();
          }
        });
        permisosService.localStorageError().subscribe(error => {
          if (error) {
            this.logout();
          }
        });
    }

    isLoggedIn(): Observable<boolean> {
      return this.logger.asObservable();
    }

    login(username: string, password: string) {
      return this.httpClient.post('/api/login', JSON.stringify({ username: username, password: password }))
        .map((response: Response) => {
          const user = response.json();
          if (user && user.token) {
            const jwt = jwt_decode(user.token);
            localStorage.setItem('token', user.token);
            localStorage.setItem('username', username);
            localStorage.setItem('userId', user.userId);
            localStorage.setItem('acopiosNetwork', jwt.acopiosNetwork);
            localStorage.setItem('accionesId', jwt.accionesId);
            this.permisosService.limpiarPermisos();
            this.logger.next(true);
            // this.firebaseService.requestPermissions().subscribe( token => {
            //     this.registerFirebaseToken(token).subscribe(res => {});
            // });
          }

          return user;
        });
    }

    logout(sessionExpired = false) {
      if (this.logoutStopCondition) {
        return;
      } else {
        this.logoutStopCondition = true;
      }

      // const firebaseToken = localStorage.getItem('firebaseToken');
      // this.firebaseService.deleteFirebaseToken(false, firebaseToken).subscribe(response => {
      // });
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('userId');
      localStorage.removeItem('firebaseToken');
      localStorage.removeItem('accionesId');
      sessionStorage.removeItem('currentAgroView');

      this.negociosService.resetListSettings();
      this.permisosService.limpiarPermisos();
      this.agrisService.deleteOficinaSucursal();
      this.signalRService.disconnect();

      if (!location.href.includes('localhost')) {
        let url = environment.EXTERNAL_BASE_URL.split('v2')[0] + 'v2/login';
        if (sessionExpired) url = url.concat('?returnReason=inactivity');

        window.open(url, '_self');
      } else {
        this.router.navigateByUrl(PATH_LOGIN);
      }
    }

    registerFirebaseToken(token: string) {
      return this.httpClient.post(`/api/user/register-push-token/`, {
        PushToken: token,
        userId: localStorage.getItem('userId'),
        Mobile: false
      });
    }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/auth-service.ts